import logo from '../img/logo.png';
import bhs from '../bhs.js';
import bhcalc from '../bhcalc.js'
import { useNavigate } from "react-router-dom";
import { useState } from 'react';

function Login() {
  const bhsSignIn = bhs(state => state.userSignedIn);
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const signIn = new FormData(e.target);
      const { data } = await bhcalc.post('/auth', {
        username: signIn.get("username"),
        password: signIn.get("password"),
      });

      if (data && data.access_token) {
        bhsSignIn(data.access_token);
        const payload = JSON.parse(atob(data.access_token.split('.')[1]));
        navigate(payload.requirePasswordChange ? "/update-password" : "/dashboard");
      } else {
        setError('Invalid credentials. Please try again.');
      }
    } catch (err) {
      console.error("Authentication error:", err);
      if (err.response?.status === 401) {
        setError('Invalid username or password.');
      } else if (err.response?.status === 500) {
        setError('Server error. Please try again later.');
      } else if (err.code === 'ECONNABORTED') {
        setError('Request timeout. Please check your connection.');
      } else {
        setError('Unable to connect to server. Please try again.');
      }
    }
  }

  return (
    <div className="flex grid justify-items-center items-center">
      <div className="w-1/2 rounded self-center bg-slate-50 pt-5">
        <div className="grid flex justify-items-center items-center pb-3">
          <img src={logo} alt="logo" className="w-1/2 pt-7" />
        </div>
        <form onSubmit={handleSignIn} className="bg-slate-50 px-8 pt-6 pb-8 mb-4">
          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
          )}
          <div className="mb-4">
            <label className="block text-gray-700 text-left text-sm font-bold mb-2" htmlFor="username">
              Username
            </label>
            <input className="text-sm/6 appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" name="username" type="text" placeholder="Username"/>
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2 text-left" htmlFor="password">
              Password
            </label>
            <input className="text-sm/6 appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="password" name="password" type="password" placeholder="*********" />
          </div>
          <div className="flex items-center justify-between">
            <button type="submit"
                   className="bg-blue-500 text-base hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
              Sign In
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
